import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { getIconStyles as o } from "../styles.js";
const n = (i) => /* @__PURE__ */ e(
  "svg",
  {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: o(i),
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#clip0_8888_10709)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.13348 9.87663C-0.367411 11.3775 -0.367411 13.811 1.13348 15.3118L9.2863 23.4647C10.7872 24.9656 13.2206 24.9656 14.7215 23.4647L22.8743 15.3118C24.3752 13.811 24.3752 11.3775 22.8743 9.87663L14.7215 1.72381C13.2206 0.222921 10.7872 0.222921 9.2863 1.72381L1.13348 9.87663ZM12 18.5942C15.3137 18.5942 18 15.9079 18 12.5942C18 9.28053 15.3137 6.59424 12 6.59424C8.68629 6.59424 6 9.28053 6 12.5942C6 15.9079 8.68629 18.5942 12 18.5942Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.4762 10.1897C10.1834 9.89684 9.70848 9.89684 9.41558 10.1897C9.12269 10.4826 9.12269 10.9575 9.41558 11.2504L10.9393 12.7741L9.48578 14.2277C9.19289 14.5206 9.19289 14.9955 9.48578 15.2884C9.77868 15.5813 10.2535 15.5813 10.5464 15.2884L12 13.8348L13.4532 15.288C13.7461 15.5809 14.221 15.5809 14.5139 15.288C14.8067 14.9951 14.8067 14.5202 14.5139 14.2273L13.0607 12.7741L14.5841 11.2508C14.8769 10.9579 14.8769 10.483 14.5841 10.1901C14.2912 9.8972 13.8163 9.8972 13.5234 10.1901L12 11.7135L10.4762 10.1897Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_8888_10709", children: /* @__PURE__ */ l(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0 0.598145)"
        }
      ) }) })
    ]
  }
);
export {
  n as DiamondCrossIcon
};
//# sourceMappingURL=DiamondCrossIcon.js.map
